import { useEffect } from 'react'
import Lenis from 'lenis'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Hero from './components/Hero'
import SobreMi from './components/SobreMi'
import MarqueeStrip from './components/Marquee'
import Proyectos from './components/Proyectos'
import Auditoria from './components/Auditoria'
import Contacto from './components/Contacto'
import Footer from './components/Footer'
import CustomCursor from './components/CustomCursor'
import WhatsAppButton from './components/WhatsAppButton'
import CookieBanner from './components/CookieBanner'
import AdminLogin from './components/admin/AdminLogin'
import AdminDashboard from './components/admin/AdminDashboard'
import { SiteContentProvider } from './contexts/SiteContentContext'
import './App.css'

function Portfolio() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    })
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf) }
    const rafId = requestAnimationFrame(raf)
    return () => { cancelAnimationFrame(rafId); lenis.destroy() }
  }, [])

  return (
    <div className="bg-black text-white overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <SobreMi />
        <MarqueeStrip />
        <Proyectos />
        <Auditoria />
        <Contacto />
      </main>
      <Footer />
      <WhatsAppButton />
      <CookieBanner />
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <SiteContentProvider>
        <CustomCursor />
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </SiteContentProvider>
    </BrowserRouter>
  )
}

export default App
